/**
 * Session Events
 * Lets the axios interceptor (outside the React tree) notify AuthContext
 * when a session dies (e.g. refresh token expired/invalid).
 */

type SessionExpiredHandler = () => void

let handler: SessionExpiredHandler | null = null

export function registerSessionExpiredHandler(fn: SessionExpiredHandler): () => void {
  handler = fn
  return () => {
    if (handler === fn) {
      handler = null
    }
  }
}

export function emitSessionExpired(): void {
  handler?.()
}
